<script>
    import {getAlerts, getUnviewedAlerts} from "../firestore";
    import {merge, from} from "rxjs"
    import {mergeMap, map, toArray} from "rxjs/operators";
    import {getPercentageFB} from "../utils";
    import {push} from "svelte-spa-router"

    let notifications = [];

    merge(getUnviewedAlerts(false), getAlerts(false)).pipe(
            toArray(),
            map(alertArray => alertArray.sort((a, b) => new Date(a.gqlsensor.lastMessage.date) - new Date(b.gqlsensor.lastMessage.date))),
            mergeMap(alertArray => from(alertArray))
    ).subscribe(alert => {
        let description_details = alert.alert_details.level === "DANGER" ? "Critical Level" : "Warning Level";

        notifications = [...notifications, {
            title: alert.sensor_details.name,
            level: getPercentageFB(parseFloat(alert.gqlsensor.lastMessage.value), alert.sensor_details).toFixed(0) + "%",
            description: description_details,
            time: new Date(alert.gqlsensor.lastMessage.date).toLocaleString(),
            icon: "dist/img/silot_icon_white.png",
            state: alert.alert_details.level.toLowerCase(),
            url: "#/equipment/" + alert.gqlsensor._id,
            id: alert.id,
            viewed: alert.viewed,
        }];
    });

    function changeViewed(notif) {
        firebase.firestore().collection("alerts").doc(notif.id).set({viewed: true}, {merge: true});
        push(notif.url);
    }
</script>

<div class="card">
    <div class="card-body">
        <div class="card-head">
            <h2 class="card-title">All alerts</h2>
        </div>
        <div class="month-table">
            <div class="table-responsive mt-3">
                <table class="table stylish-table mb-0">
                    <thead>
                    <tr>
                        <th colspan="2">Equipment</th>
                        <th>Alert level</th>
                        <th>State</th>
                        <th>Date</th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each notifications as notif}
                        <tr on:click={() => changeViewed(notif)}>
                            <td>
                                <div class="btn btn-{notif.state} btn-circle">
                                    <img class="silot" src={notif.icon} width="30">
                                    <div class="notify">
                                        {#if !notif.viewed}
                                            <span class="heartbit"></span>
                                            <span class="point"></span>
                                        {/if}
                                    </div>
                                </div>
                            </td>
                            <td>
                                <h6>{notif.title}</h6>
                                <small class="text-muted">{notif.description}</small>
                            </td>
                            <td>
                                <div>{notif.level}</div>
                            </td>
                            <td>
                                <span class="badge badge-{notif.state} px-2 py-1">{notif.state.toUpperCase()}</span>
                            </td>
                            <td>
                                <span class="time">{notif.time}</span>
                            </td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
